module.exports = __webpack_public_path__ + "media/src/components/ApplicantReview/img/turtle-0fd717ab8f413c15e520d9d1b75dd0e5.jpg";